import React, { Component } from 'react'
import BackLogo from '../../../../images/rewampimages/Chevron.png'
import CompleteLeadsUi from './CompleteLeads.container'
import IncompleteLeadsUi from './IncompleteLeads.container'
import PartialLeadsUi from './PartialLeads.container'
import RepeateLeadsUi from './RepeateLeads.container'
import CollectionLeads from './CollectionLeads.container'
import DashboardUi from './LeadsDashboard.container'
import LegalLeads from './legalLeads.container'

import CustomInfoOption from './LeadCount/CustomInfoOption'

import { APIS } from '../../../../utils/api-factory'
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { ROLE } from '../../../../utils/Constant'
import { CustomLeadManagementAllDataListShow, EmailcheckFn } from '../../../../utils/CustomEmailCheck'
let assignuser = []
class LeadManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageToShow: '',
            userStatusData: [],
            adminMail: '',
            detailpage: false,
            viewType: 'LM',
            leadViewType: 'AssignedLeadsOlderThanDay'
        }
    }
    getAssignedByStatus() {
        const { admin } = this.props
        if (admin !== undefined) {
            if (admin.department === 'Recovery Team') {
                this.setState({
                    // userStatusData: status,
                    pageToShow: 'overdue',
                })
            } else {
                fetch(APIS.GET_ASSIGN_BY_STATUS)
                    .then(res => res.json())
                    .then(res => {
                        res.map((status, i) => {
                            assignuser.push(status.emailId + status.status)
                            this.setState({
                                userStatusData: status,
                                pageToShow: assignuser.includes(admin.emailId + 'complete') ? 'complete' : assignuser.includes(admin.emailId + 'incomplete') ? 'incomplete' : assignuser.includes(admin.emailId + 'repeat') ? 'repeate' : assignuser.includes(admin.emailId + 'partialcomplete') ? 'partial' : assignuser.includes(admin.emailId + 'legal') ? 'legal' : assignuser.includes(admin.emailId + 'overdue') ? 'overdue' : admin.role === 'superuser' ? 'complete' : "",
                            })

                        })

                    })
            }
        }
    }

    hanldeviewType(type) {
        this.setState({ viewType: type })
        this.handleleadViewType("AssignedLeadsOlderThanDay")
    }



    componentDidMount() {
        const { admin } = this.props
        this.getAssignedByStatus()
    }
    setDetailsPage(data) {
        this.setState({ detailpage: data })
        console.log(data, 'datadata')
    }

    handleleadViewType(type) {
        this.setState({ leadViewType: type })
    }

    handleRoleForApi() {
        const { admin } = this.props;
        if (EmailcheckFn(admin.emailId, CustomLeadManagementAllDataListShow)) {
            return "superuser"
        }

        else return ""
    }

     handlePageState(){
        // const {pageState} = this.props;
        // if(pageState == "EvApplications") return true;
        return false;
    }

    render() {
        const { admin, allStatus, newDataBackground, pageViewHandler } = this.props
        return (
            <>
                {
                    this.state.detailpage === false ?

                        <div className="container-fluid details-new fixed-top" style={{ zIndex: '3' }} >
                            <div className="row details-new-tab-div" style={{ display: 'flex', justifyContent: 'end' }}>
                                <div className="col-sm-6 col-xs-12 " style={{ marginTop: '15px' }}>
                                    <img onClick={(e) => pageViewHandler(e, 'landingPage')} style={{ cursor: 'pointer' }} src={BackLogo} width={'30px'} /> <button style={{ color: '#1D3557', fontWeight: '700' }} onClick={(e) => pageViewHandler(e, 'landingPage')} >Back</button>
                                </div>

                                <div className=" col-lg-6 col-xs-12" style={{ fontSize: '10px', display: 'flex', justifyContent: 'end' }}>


                                    <div className="btn-group-new">
                                        <button className={(this.state.viewType === 'LM') ? "active" : ""} style={{ fontSize: '14px' }} onClick={() => this.hanldeviewType('LM')}><LeaderboardIcon /> <br />Leads</button>
                                        {
                                            admin.rolelist != undefined ?
                                                admin.rolelist.indexOf(ROLE.LM_Lead_Count) >= 0 ?
                                                    <button className={(this.state.viewType === 'Leads') ? "active" : ""} style={{ fontSize: '14px' }} onClick={() => this.hanldeviewType('Leads')}><ConfirmationNumberIcon /> <br />Lead count</button>
                                                    : '' : ""}
                                    </div>

                                </div>
                            </div>
                        </div>
                        : ''}
                {
                    this.state.viewType == "LM" ?

                        <div className="full-height" style={{ marginTop: '70px' }}>
                            <div className="edit-profile-menu col-xs-12">
                                {/* {admin.role !== 'superuser' ?
                        <div className="btn-group-own">
                            {assignuser.includes(admin.emailId + 'complete') || admin.department === 'Customer Service' ?
                                <button className={this.state.pageToShow == 'complete' ? 'active' : ''} onClick={e => this.buttonActionHandler("complete")}>Complete</button>
                                : ""}
                            {assignuser.includes(admin.emailId + 'partialcomplete') ?

                                <button className={this.state.pageToShow == 'partial' ? 'active' : ''} onClick={e => this.buttonActionHandler("partial")}>Partial</button>
                                : ""}
                            {assignuser.includes(admin.emailId + 'incomplete') ?

                                <button className={this.state.pageToShow == 'incomplete' ? 'active' : ''} onClick={e => this.buttonActionHandler("incomplete")}>Incomplete</button>
                                : ""}
                            {assignuser.includes(admin.emailId + 'repeat') ?
                                <button className={this.state.pageToShow == 'repeate' ? 'active' : ''} onClick={e => this.buttonActionHandler("repeate")}>Repeat</button>
                                : ""}
                            {assignuser.includes(admin.emailId + 'legal') ?
                                <button className={this.state.pageToShow == 'legal' ? 'active' : ''} onClick={e => this.buttonActionHandler("legal")}>Legal</button>
                                : ""}

                            <button className={this.state.pageToShow == 'dashboard' ? 'active' : ''} onClick={e => this.buttonActionHandler("dashboard")}>Dashboard</button>
                        </div>
                        : ""
                    } */}
                                {admin.role !== 'superuser' && this.state.detailpage === false ?
                                    <div className="btn-grp-own-lead-manage" role="group" aria-label="onboard-btn" style={{ padding: '10px' }}>
                                        {assignuser.includes(admin.emailId + 'complete') || admin.department === 'Customer Service' ?
                                            <button className={this.state.pageToShow == 'complete' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("complete")}>Complete</button>
                                            : ""}
                                        {assignuser.includes(admin.emailId + 'partialcomplete') ?

                                            <button className={this.state.pageToShow == 'partial' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("partial")}>Partial</button>
                                            : ""}
                                        {assignuser.includes(admin.emailId + 'incomplete') ?

                                            <button className={this.state.pageToShow == 'incomplete' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("incomplete")}>Incomplete</button>
                                            : ""}
                                        {assignuser.includes(admin.emailId + 'legal') ?
                                            <button className={this.state.pageToShow == 'legal' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("legal")}>Operation</button>
                                            : ""}
                                        {assignuser.includes(admin.emailId + 'repeat') ?
                                            <button className={this.state.pageToShow == 'repeate' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("repeate")}>Repeat</button>
                                            : ""}

                                        <button className={this.state.pageToShow == 'dashboard' ? 'btn-active' : 'btn'} onClick={e => this.buttonActionHandler("dashboard")}>Dashboard</button>
                                    </div>
                                    : ""
                                }




                                {
                                    admin.role === 'superuser' && this.state.detailpage === false ?
                                        <>

                                            <div style={{ marginBottom: '30px', display: 'flex', justifyContent: 'end' }}>
                                                <button className={`btn-lm ${this.state.pageToShow == "complete" ? "btn-active-lm" : ""}`} onClick={e => this.buttonActionHandler("complete")}>Complete&nbsp;<span style={{ fontSize: '10px' }}>(Credit)</span></button>
                                                <button className={`btn-lm ${this.state.pageToShow == "incomplete" ? "btn-active-lm" : ""}`} onClick={e => this.buttonActionHandler("incomplete")}>Incomplete&nbsp;<span style={{ fontSize: '10px' }}> (Customer Service)</span></button>
                                                <button className={`btn-lm ${this.state.pageToShow == "legal" ? "btn-active-lm" : ""}`} onClick={e => this.buttonActionHandler("legal")}>Operation</button>
                                                <button className={`btn-lm ${this.state.pageToShow == "repeate" ? "btn-active-lm" : ""}`} onClick={e => this.buttonActionHandler("repeate")}>Repeat</button>
                                                <button className={`btn-lm ${this.state.pageToShow == "dashboard" ? "btn-active-lm" : ""}`} onClick={e => this.buttonActionHandler("dashboard")}>Dashboard</button>

                                            </div>
                                        </>
                                        : ""}
                            </div >
                            {
                                this.state.pageToShow == 'complete' ?
                                    <CompleteLeadsUi
                                        setDetailsPage={this.setDetailsPage.bind(this)}
                                        admin={admin}
                                        allStatus={allStatus}
                                        newDataBackground={newDataBackground}
                                        handleRoleForApi={this.handleRoleForApi.bind(this)}
                                        handlePageState={this.handlePageState.bind(this)}
                                    />
                                    : this.state.pageToShow == 'incomplete' ?
                                        <IncompleteLeadsUi
                                            setDetailsPage={this.setDetailsPage.bind(this)}

                                            admin={admin}
                                            allStatus={allStatus}
                                             handleRoleForApi={this.handleRoleForApi.bind(this)}
                                              handlePageState={this.handlePageState.bind(this)}
                                            newDataBackground={newDataBackground} />
                                        : this.state.pageToShow == 'partial' ?
                                            <PartialLeadsUi
                                                setDetailsPage={this.setDetailsPage.bind(this)}

                                                admin={admin}
                                                allStatus={allStatus}
                                                newDataBackground={newDataBackground} />
                                            : this.state.pageToShow == 'repeate' ?
                                                <RepeateLeadsUi
                                                    setDetailsPage={this.setDetailsPage.bind(this)}
                                                    handleRoleForApi={this.handleRoleForApi.bind(this)}
 handlePageState={this.handlePageState.bind(this)}
                                                    admin={admin}
                                                    allStatus={allStatus}
                                                    newDataBackground={newDataBackground} />
                                                : this.state.pageToShow == 'overdue' ?
                                                    <CollectionLeads
                                                        setDetailsPage={this.setDetailsPage.bind(this)}

                                                        admin={admin}
                                                        allStatus={allStatus}
                                                        newDataBackground={newDataBackground} />
                                                    : this.state.pageToShow == 'legal' ?
                                                        <LegalLeads
                                                         handlePageState={this.handlePageState.bind(this)}
                                                            setDetailsPage={this.setDetailsPage.bind(this)}
                                                            handleRoleForApi={this.handleRoleForApi.bind(this)}

                                                            pageToShow={this.state.pageToShow}
                                                            admin={admin}
                                                            allStatus={allStatus}
                                                            newDataBackground={newDataBackground} />
                                                        : this.state.pageToShow == 'dashboard' ?
                                                            <DashboardUi
                                                                setDetailsPage={this.setDetailsPage.bind(this)}

                                                                admin={admin}
                                                                allStatus={allStatus} />

                                                            : null
                            }
                        </div >
                        : ''}

                {
                    this.state.viewType == "Leads" ?
                        <>
                            {/* <div className="btn-grp-own-lead-manage" role="group" aria-label="onboard-btn" style={{ padding: '10px',marginTop:'90px' }}>
                                <button style={{ width: '50%' }} className={this.state.leadViewType == 'AssignedLeadsOlderThanDay' ? 'btn-active TabActiveBackgroundEffect' : 'btn'} onClick={e => this.handleleadViewType("AssignedLeadsOlderThanDay")}>Assigned Older Leads</button>
                                <button style={{ width: '50%' }} className={this.state.leadViewType == 'leadcount' ? 'btn-active TabActiveBackgroundEffect' : 'btn'} onClick={e => this.handleleadViewType("leadcount")}>Lead Count</button>
                            </div> */}
                            {
                                this.state.detailpage === false ?

                                    <div style={{ marginTop: '70px', display: 'flex', justifyContent: 'end' }}>
                                        <button className={`btn-lm ${this.state.leadViewType == "AssignedLeadsOlderThanDay" ? "btn-active-lm" : ""}`} onClick={e => this.handleleadViewType("AssignedLeadsOlderThanDay")}>Assigned Older Leads</button>
                                        <button className={`btn-lm ${this.state.leadViewType == "leadcount" ? "btn-active-lm" : ""}`} onClick={e => this.handleleadViewType("leadcount")}>Lead Count</button>
                                    </div>
                                    : ''}

                            {
                                this.state.leadViewType == 'AssignedLeadsOlderThanDay' || this.state.leadViewType == 'leadcount' ?
                                    <CustomInfoOption
                                        setDetailsPage={this.setDetailsPage.bind(this)}
                                        admin={admin}
                                        allStatus={allStatus}
                                        viewType={this.state.leadViewType}
                                          handlePageState={this.handlePageState.bind(this)}
                                    />
                                    : ''}


                        </>
                        : ''}
            </>
        )
    }

    buttonActionHandler(type) {

        this.setState({
            pageToShow: type
        })
    }
}

export default LeadManagement;